
export const SIDEBARACTIVEBUTTON = 'SIDEBARACTIVEBUTTON'
export const SIDEBARACTIVESTATE = 'SIDEBARACTIVESTATE'


export const addSideBarActiveButton = data => (
    {
        type: SIDEBARACTIVEBUTTON,
        payload: data
    }

)
export const addSideBarActiveState = data => (
    {
        type: SIDEBARACTIVESTATE,
        payload: data
    }

)
const initialstate = {
    sidebaractivebutton: 'basicmode',
    sidebaractivestate: false
}

const SidebarActiveButtonReducer = (state = initialstate, action) => {
    switch (action.type) {
        case SIDEBARACTIVEBUTTON:
            return {
                ...state,
                sidebaractivebutton: action.payload

            }
        case SIDEBARACTIVESTATE:
            return {
                ...state,
                sidebaractivestate: action.payload

            }
        default:
            return state;
    }
}
export default SidebarActiveButtonReducer;